import React from 'react';
import SavedPaymentMethodCard from './SavedPaymentMethodCard';
import SavedPaymentMethodBank from './SavedPaymentMethodBank';
import {
  PaymentMethod,
  isCardPaymentMethod,
  isUsBankAccountPaymentMethod,
  StripePaymentMethodType
} from './stripe.types';

type Props = {
  method?: PaymentMethod | null;
};

export default function SavedPaymentMethod({ method }: Props) {
  if (!method) {
    return (
      <div style={{ padding: '1rem', color: '#555' }}>
        No payment method on file.
      </div>
    );
  }

  if (isCardPaymentMethod(method)) {
    return <SavedPaymentMethodCard method={method} />;
  }

  if (isUsBankAccountPaymentMethod(method)) {
    return <SavedPaymentMethodBank method={method} />;
  }

  return (
    <div style={{ padding: '1rem', color: '#555' }}>
      Unsupported payment method type: {(method as any).type}
    </div>
  );
}

// Export the type for use in other components
export type { StripePaymentMethodType };
